<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3122 22.7077C19.3577 22.7077 21.8495 20.2159 21.8495 17.1704V9.7873C21.8495 6.74178 19.3577 4.25 16.3122 4.25C13.2667 4.25 10.7749 6.74178 10.7749 9.7873V17.1704C10.7749 20.2159 13.2667 22.7077 16.3122 22.7077Z"
      :fill="fill"
    />
    <path
      d="M25.5412 17.1701C25.5412 16.6163 25.172 16.2472 24.6183 16.2472C24.0645 16.2472 23.6954 16.6163 23.6954 17.1701C23.6954 21.2307 20.373 24.5531 16.3123 24.5531C12.2516 24.5531 8.92926 21.2307 8.92926 17.1701C8.92926 16.6163 8.56011 16.2472 8.00638 16.2472C7.45265 16.2472 7.0835 16.6163 7.0835 17.1701C7.0835 21.9691 10.775 25.8452 15.3894 26.3066V28.2447H10.775C10.2213 28.2447 9.85214 28.6138 9.85214 29.1675C9.85214 29.7213 10.2213 30.0904 10.775 30.0904H21.8496C22.4034 30.0904 22.7725 29.7213 22.7725 29.1675C22.7725 28.6138 22.4034 28.2447 21.8496 28.2447H17.2352V26.3066C21.8496 25.8452 25.5412 21.9691 25.5412 17.1701Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
    fill: {
      type: String,
      default: "#8D5185",
    },
  },
};
</script>

<style lang="scss" scoped></style>
